<template>
  <div v-if="type !== 'foreign_key'">
    <template v-if="option.type=='dict'">
      <div class="font-weight-bold subtitle-1 text-left mb-3">
        {{ option.label }}
      </div>
      <template v-if="option.sub_options">
        <v-row>
          <v-col
            v-for="(sub_o,sub_o_index) in option.sub_options"
            :key="sub_o_index"
            class="py-0"
          >
            <field-option
              :name="sub_o_index"
              :constraint="constraint?(constraint.sub_options?constraint.sub_options.find(c=>c.name === sub_o.name):null):null"
              :type="type"
              :option="sub_o"
              @update="v => handleUpdate(v,sub_o,option)"
            />
          </v-col>
        </v-row>
      </template>
    </template>
    <template v-else-if="['integer','float'].includes(option.type)">
      <v-text-field
        v-model.number="value"
        small
        outlined
        :label="option.label"
        type="number"
      />
    </template>
    <template v-else-if="option.type=='boolean'">
      <v-checkbox
        v-model="value"
        small
        outlined
        :label="option.label"
      />
    </template>
    <template v-else-if="option.type=='timestamp'">
      <div class="subtitle text-left">
        {{ option.label }}
      </div>
      <date-time-picker
        v-model="value"
        outlined
      />
    </template>
    <template v-else-if="option.type=='date'">
      <div class="subtitle text-left">
        {{ option.label }}
      </div>
      <date-time-picker
        v-model="value"
        outlined
        date-only
      />
    </template>
    <template v-else>
      Option type not supported : {{ option.name }} ({{ option.type }})
    </template>
  </div>
</template>

<script>
  import FieldOption from './FieldOption'
  import DateTimePicker from './../../../UIComponents/DateTimePicker'
  import _ from 'lodash'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  export default {
    name: 'FieldOption',
    components: {
      DateTimePicker,
      FieldOption,
    },
    mixins: [validationMixin],
    validations: {
    },
    props: {
      option: {
        type: Object,
        default: null,
      },
      constraint: {
        type: Object,
        default: null,
      },
      type: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        value: '',
      }
    },
    computed: {
    },
    watch: {
      type (nv, ov) {
        this.value = ''
      },
      value: {
        deep: true,
        handler (nv, ov) {
          // const keys = Object.keys(this.values)
          this.$emit('update', this.value)
        //   if (keys.length > 1) {
        //   } else if (keys.length === 1) { this.$emit('update', this.values[keys[0]]) }
        },
      },
    },
    mounted () {
      this.patchValues()
    },
    methods: {
      patchValues () {
        if (this.constraint) {
          this.handleUpdate(this.constraint.value, this.option, null)
        }
      },
      handleUpdate (value, option, parentOption) {
        if (parentOption) {
          if (!this.value) { this.value = {} }
          this.value[option.name] = value
          this.$emit('update', this.value)
        } else {
          this.value = value
          this.$emit('update', this.value)
        }
        this.$forceUpdate()
      },
    },
  }
</script>
